import Goals from '@/components/views/dashboard/goals/Goals.vue';
import Welcome from '@/components/views/dashboard/Welcome.vue';
import DashboardHome from '@/components/views/dashboard/DashboardHome.vue';
import Growth from '@/components/views/dashboard/growth/Growth.vue';
import Booklets from '@/components/views/dashboard/booklets/Booklets.vue';
import Help from '@/components/views/dashboard/help/Help.vue';
import GoalsWrapper from '@/components/views/dashboard/goals/GoalsWrapper.vue';
import GoalsLearnMore from '@/components/views/dashboard/goals/GoalsLearnMore.vue';
import GoalsQuestions from '@/components/views/dashboard/goals/GoalsQuestions.vue';
import GoalsPast from '@/components/views/dashboard/goals/GoalsPast.vue';
import GoalInfo from '@/components/views/dashboard/goals/GoalInfo.vue';
import GoalWrapper from '@/components/views/dashboard/goals/GoalWrapper.vue';
import BookletView from '@/components/views/dashboard/booklets/BookletView.vue';
import GoalsQuestionView from '@/components/views/dashboard/goals/GoalsQuestionView.vue';
import BookletsWrapper from '@/components/views/dashboard/booklets/BookletsWrapper.vue';
import {RawLocation, Route, RouterOptions} from 'vue-router';

const dashboardChildren = [
    {
        path: '',
        name: 'dashboard.home',
        component: DashboardHome,
        props: true,
        meta: {
            pageTitleConfig: {
                showPageTitle: true,
                showBackButton: false,
                pageTitle: 'INTRO.PAGE_TITLE',
                pageTitleParams: null,
                backButtonLink: '',
                showFooterNav: true
            }
        },
    },
    {
        path: 'welcome',
        name: 'dashboard.welcome',
        component: Welcome,
        props: true,
        meta: {
            pageTitleConfig: {
                showPageTitle: false,
                showBackButton: false,
                pageTitle: '',
                pageTitleParams: null,
                backButtonLink: null,
                showFooterNav: false
            }
        }
    },
    {
        path: 'goals',
        component: GoalsWrapper,
        name: 'dashboard.goals',
        redirect: {name: 'dashboard.goals.goal'},
        children: [
            {
                /**
                 * the `id` will be 'latest' for viewing the last goal or a string/number to reference a previous goal
                 */
                path: 'view/:id',
                component: GoalWrapper,
                children: [
                    {
                        path: '',
                        name: 'dashboard.goals.goal',
                        component: GoalInfo,
                        props: true,
                        meta: {
                            pageTitleConfig: {
                                showPageTitle: true,
                                showBackButton: false,
                                pageTitle: 'GOAL.PAGE_TITLE',
                                pageTitleParams: null,
                                backButtonLink: '',
                                showFooterNav: true
                            }
                        },
                    },
                    {
                        path: 'learn-more',
                        name: 'dashboard.goals.goal.learnmore',
                        component: GoalsLearnMore,
                        props: true,
                        meta: {
                            pageTitleConfig: {
                                showPageTitle: true,
                                showBackButton: true,
                                pageTitle: 'GOAL.LEARN_MORE.PAGE_TITLE',
                                pageTitleParams: null,
                                backButtonLink: {name: 'dashboard.goals.goal'},
                                showFooterNav: true
                            }
                        },
                    },
                    {
                        path: 'questions',
                        name: 'dashboard.goals.goal.questions',
                        component: GoalsQuestions,
                        props: true,
                        meta: {
                            pageTitleConfig: {
                                showPageTitle: true,
                                showBackButton: true,
                                pageTitle: 'GOAL.QUESTIONS.PAGE_TITLE',
                                pageTitleParams: null,
                                backButtonLink: {name: 'dashboard.goals.goal'},
                                showFooterNav: true
                            }
                        },
                    },
                    {
                        path: 'questions/:qid',
                        name: 'dashboard.goals.goal.questions.view',
                        component: GoalsQuestionView,
                        props: true,
                        meta: {
                            pageTitleConfig: {
                                showPageTitle: true,
                                showBackButton: true,
                                pageTitle: 'GOAL.QUESTIONS.PAGE_TITLE',
                                pageTitleParams: null,
                                backButtonLink: {name: 'dashboard.goals.goal.questions'},
                                showFooterNav: true
                            }
                        },
                    },
                ]
            },
            {
                path: 'past',
                name: 'dashboard.goals.past',
                component: GoalsPast,
                props: true,
                meta: {
                    pageTitleConfig: {
                        showPageTitle: true,
                        showBackButton: true,
                        pageTitle: 'GOAL.PAST.PAGE_TITLE',
                        pageTitleParams: null,
                        backButtonLink: {name: 'dashboard.goals.goal', params: {id: 'latest'}},
                        showFooterNav: true
                    }
                },
            }
        ]
    },
    {
        path: 'growth',
        name: 'dashboard.growth',
        component: Growth,
        props: true,
        meta: {
            pageTitleConfig: {
                showPageTitle: true,
                showBackButton: false,
                pageTitle: 'GROWTH.PAGE_TITLE',
                pageTitleParams: null,
                backButtonLink: '',
                showFooterNav: true
            }
        }
    },

    /**
     * the `goalid` will be 'latest' for viewing the last goal or a string/number to reference a previous goal
     */

    {
        path: 'booklets',
        component: BookletsWrapper,
        name: 'dashboard.booklets',
        redirect: {name: 'dashboard.booklets.goal'},
        children: [
            {
                path: ':goalid',
                name: 'dashboard.booklets.goal',
                component: Booklets,
                props: true,
                meta: {
                    pageTitleConfig: {
                        showPageTitle: true,
                        showBackButton: false,
                        pageTitle: 'BOOKLETS.PAGE_TITLE',
                        pageTitleParams: null,
                        backButtonLink: '',
                        showFooterNav: true
                    }
                }
            },
            {
                path: ':goalid/view/:id',
                name: 'dashboard.booklets.view',
                component: BookletView,
                props: true,
                meta: {
                    pageTitleConfig: {
                        showPageTitle: true,
                        showBackButton: true,
                        pageTitle: 'BOOKLETS.PAGE_TITLE',
                        pageTitleParams: null,
                        backButtonLink: {name: 'dashboard.booklets.goal'},
                        showFooterNav: true
                    }
                },
            },
        ]
    },
    {
        path: 'help',
        name: 'dashboard.help',
        component: Help,
        props: true,
        meta: {
            pageTitleConfig: {
                showPageTitle: true,
                showBackButton: false,
                pageTitle: 'HELP.PAGE_TITLE',
                pageTitleParams: null,
                backButtonLink: '',
                showFooterNav: true
            }
        }
    }
];

export default dashboardChildren;